import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=68162504&scoped=true&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=68162504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68162504",
  null
  
)

export default component.exports